<template>
	<PropertyRow :label="label" :dd-class="ddClass" :dt-class="dtClass">
		<template #actions>
			<slot name="sources" />
		</template>
		<slot />
	</PropertyRow>
</template>

<script setup lang="ts">
import { computed, provide } from "vue";
import { isEqual } from "es-toolkit";
import { propertyFieldKey, type PropertyFieldContext } from "@/keys";

defineProps<{
	label: string;
	ddClass?: string;
	dtClass?: string;
}>();

const modelValue = defineModel<unknown>();

const context: PropertyFieldContext = {
	value: computed(() => modelValue.value),
	setValue: (value: unknown) => {
		modelValue.value = value;
	},
	isActive: (sourceValue: unknown) => {
		return isEqual(modelValue.value, sourceValue);
	},
};

provide(propertyFieldKey, context);
</script>
